import {
  SCALE_DEFINITIONS,
  scaleRules,
  scaleRulesAvailable,
} from './definitions';

const getScalesFromCombination = comb => {
  const leg0 = [comb.option?.scales_qty ?? 0];

  let leg1 = [];
  if (comb.next_leg_options && comb.next_leg_options.length > 0) {
    leg1 = comb.next_leg_options.map(n => n.option?.scales_qty ?? 0);
  } else {
    leg1 = [comb.option?.scales_qty ?? 0];
  }

  return [leg0, leg1];
};

export const filterCustomByScale = (clusters, scaleSelected) => {
  if (!scaleSelected || scaleSelected === 'allOptions') {
    return [...clusters];
  }

  const rule = scaleRules[scaleSelected];
  if (!rule) {
    return [...clusters];
  }

  return clusters
    .map(cluster => {
      const combinations = cluster.combinations
        .map(comb => {
          let filteredNextLegOptions;

          if (comb?.next_leg_options?.length > 0) {
            filteredNextLegOptions = comb.next_leg_options.filter(n => {
              const scales = [[n.option?.scales_qty]];
              return rule(scales);
            });

            if (filteredNextLegOptions.length === 0) {
              return null;
            }
          }

          return { ...comb, next_leg_options: filteredNextLegOptions };
        })
        .filter(Boolean)
        .filter(comb => {
          const scales = getScalesFromCombination(comb);
          return rule(scales);
        });

      return { ...cluster, combinations };
    })
    .filter(c => c.combinations.length > 0);
};

export const getCustomClusterScales = clusters => {
  return [
    { name: 'Todas las opciones', value: 'allOptions' },
    ...Object.entries(scaleRulesAvailable)
      .filter(([_, rule]) =>
        clusters.some(cluster =>
          cluster.combinations.some(comb => {
            const scales = getScalesFromCombination(comb);
            return rule(scales);
          })
        )
      )
      .map(([key]) => ({
        value: key,
        name: SCALE_DEFINITIONS[key].label,
      })),
  ];
};
